import getConfig from 'next/config';

export const getCtaDistributionBucketedCookie = (): string => {
  const {
    publicRuntimeConfig: { CTA_DISTRIBUTION_EXPERIMENT_KEY },
  } = getConfig();
  return `convert_bucketed_${CTA_DISTRIBUTION_EXPERIMENT_KEY}`;
};
